// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from './utils/request';
import store from './store'
import VConsole from 'vconsole'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/style/global.css'
import '@/style/vant_global.css'
import '@/assets/fonts/K2D/K2D.css'
import Bridge from './utils/bridge'
import Toast from './components/Toast.vue';
import track from './utils/track'


Vue.prototype.$bridge = Bridge;
Vue.prototype.$track = track;

// Toast
const ToastConstructor = Vue.extend(Toast);
const toastInstance = new ToastConstructor();
toastInstance.$mount(document.createElement('div'));
document.body.appendChild(toastInstance.$el);

Vue.prototype.$showToast = function (message, type) {
  toastInstance.showToast(message, type);
};

const isProd = process.env.NODE_ENV === 'production'
if (!isProd) {
  const vConsole = new VConsole()
  Vue.use(vConsole)
}

Vue.use(Vant);

import './settings'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js